import React from 'react';
import { CreditCardIcon, DownloadIcon, TrashIcon, UsersIcon } from 'lucide-react';
export function BillingSettingsPage() {
  return <div className="flex flex-col pb-12 max-w-4xl" data-id="element-314">
      <h1 className="text-3xl font-bold mb-8" data-id="element-315">Settings</h1>

      <div className="space-y-10" data-id="element-316">
        {/* Billing Section */}
        <section data-id="element-317">
          <h2 className="text-xl font-bold mb-4 border-b border-border pb-2" data-id="element-318">
            Billing & Plan
          </h2>
          <div className="bg-card border border-border rounded-xl p-6 shadow-sm mb-6" data-id="element-319">
            <div className="flex justify-between items-start mb-6" data-id="element-320">
              <div data-id="element-321">
                <h3 className="font-semibold text-lg" data-id="element-322">Monitoring Plan</h3>
                <p className="text-muted-foreground text-sm" data-id="element-323">
                  1 active account
                </p>
              </div>
              <div className="text-right" data-id="element-324">
                <div className="text-2xl font-bold" data-id="element-325">
                  $19
                  <span className="text-sm text-muted-foreground font-normal" data-id="element-326">
                    /mo
                  </span>
                </div>
                <span className="inline-block px-2 py-1 bg-pk-success-light text-pk-success text-xs font-medium rounded mt-1" data-id="element-327">
                  Active
                </span>
              </div>
            </div>
            <div className="flex gap-3 pt-4 border-t border-border" data-id="element-328">
              <button className="text-sm font-medium bg-muted text-foreground px-4 py-2 rounded hover:bg-muted/80 transition-colors" data-id="element-329">
                Manage Subscription
              </button>
            </div>
          </div>

          <h3 className="font-semibold mb-3" data-id="element-330">Invoice History</h3>
          <div className="bg-card border border-border rounded-xl overflow-hidden shadow-sm" data-id="element-331">
            <table className="w-full text-sm text-left" data-id="element-332">
              <thead className="text-xs text-muted-foreground uppercase bg-muted/50 border-b border-border" data-id="element-333">
                <tr data-id="element-334">
                  <th className="px-6 py-3 font-medium" data-id="element-335">Date</th>
                  <th className="px-6 py-3 font-medium" data-id="element-336">Amount</th>
                  <th className="px-6 py-3 font-medium" data-id="element-337">Status</th>
                  <th className="px-6 py-3 font-medium text-right" data-id="element-338">Invoice</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-339">
                <tr className="hover:bg-muted/30 transition-colors" data-id="element-340">
                  <td className="px-6 py-4" data-id="element-341">Oct 1, 2023</td>
                  <td className="px-6 py-4" data-id="element-342">$19.00</td>
                  <td className="px-6 py-4" data-id="element-343">
                    <span className="text-pk-success font-medium" data-id="element-344">Paid</span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-345">
                    <button className="text-muted-foreground hover:text-foreground" data-id="element-346">
                      <DownloadIcon className="w-4 h-4 inline" data-id="element-347" />
                    </button>
                  </td>
                </tr>
                <tr className="hover:bg-muted/30 transition-colors" data-id="element-348">
                  <td className="px-6 py-4" data-id="element-349">Sep 15, 2023</td>
                  <td className="px-6 py-4" data-id="element-350">
                    $29.00{' '}
                    <span className="text-xs text-muted-foreground" data-id="element-351">
                      (Setup)
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-352">
                    <span className="text-pk-success font-medium" data-id="element-353">Paid</span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-354">
                    <button className="text-muted-foreground hover:text-foreground" data-id="element-355">
                      <DownloadIcon className="w-4 h-4 inline" data-id="element-356" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Workspace Section */}
        <section data-id="element-357">
          <h2 className="text-xl font-bold mb-4 border-b border-border pb-2" data-id="element-358">
            Workspace
          </h2>
          <div className="bg-card border border-border rounded-xl p-6 shadow-sm space-y-6" data-id="element-359">
            <div data-id="element-360">
              <label className="block text-sm font-medium mb-2" data-id="element-361">
                Workspace Name
              </label>
              <input type="text" defaultValue="Acme Corp" className="w-full max-w-md bg-background border border-border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/50" data-id="element-362" />
            </div>

            <div className="pt-4 border-t border-border" data-id="element-363">
              <div className="flex justify-between items-center mb-4" data-id="element-364">
                <div data-id="element-365">
                  <h3 className="font-semibold flex items-center gap-2" data-id="element-366">
                    Team Members
                    <span className="text-xs bg-pk-info-light text-pk-info-dark px-2 py-0.5 rounded font-medium" data-id="element-367">
                      Coming Soon
                    </span>
                  </h3>
                  <p className="text-sm text-muted-foreground" data-id="element-368">
                    Invite your team to view implementation packs.
                  </p>
                </div>
                <button disabled className="text-sm font-medium bg-muted text-muted-foreground px-4 py-2 rounded opacity-50 cursor-not-allowed flex items-center gap-2" data-id="element-369">
                  <UsersIcon className="w-4 h-4" data-id="element-370" />
                  Invite
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Danger Zone */}
        <section data-id="element-371">
          <h2 className="text-xl font-bold mb-4 border-b border-border pb-2 text-pk-error" data-id="element-372">
            Danger Zone
          </h2>
          <div className="border border-pk-error/30 bg-pk-error-light/10 rounded-xl p-6 flex justify-between items-center" data-id="element-373">
            <div data-id="element-374">
              <h3 className="font-semibold text-pk-error mb-1" data-id="element-375">
                Delete Workspace
              </h3>
              <p className="text-sm text-muted-foreground" data-id="element-376">
                Permanently delete your workspace and all configuration data.
                This cannot be undone.
              </p>
            </div>
            <button className="text-sm font-medium bg-pk-error text-white px-4 py-2 rounded hover:bg-pk-error/90 transition-colors flex items-center gap-2" data-id="element-377">
              <TrashIcon className="w-4 h-4" data-id="element-378" />
              Delete
            </button>
          </div>
        </section>
      </div>
    </div>;
}